import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { ListTable } from 'gnos-tables'
import _ from 'lodash'

import Signals from '../../../../../../../../../../../../../components/TableCell/components/Signals'
import Entity from '../../../../../../../../../../../../../components/TableCell/components/Entity'

import { LOCALE_PREFIX } from '../../../../constants'
import hocConnect from './hocConnect'

import './style.scss'

@injectIntl
@hocConnect
export default class Participants extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        contractsLoadDocParticipants: PropTypes.func.isRequired,
        customData: PropTypes.object,
        dataLocale: PropTypes.string,
        docId: PropTypes.number.isRequired,
        entId: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        isLoading: PropTypes.bool,
        level: PropTypes.string,
        locale: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        participants: PropTypes.array,
        row: PropTypes.object,
    }

    componentDidMount() {
        const {
            module,
            block,
            entId,
            level,
            locale,
            dataLocale,
            docId,
            customData,
            participants,
            contractsLoadDocParticipants,
        } = this.props

        if (_.isEmpty(participants) || locale !== dataLocale) {
            contractsLoadDocParticipants(module, block, entId, level, docId, customData)
        }
    }

    render() {
        const { isLoading, entId, docId, participants, row, intl } = this.props

        return (
            <div className={'participants-container'}>
                <div className={'full-contract-name-container'}>
                    <div className={'header-container'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.fullContractName`} />
                    </div>
                    <div className={'name-container'}>{_.get(row, 'name', null)}</div>
                </div>
                <div className={'table-container'}>
                    {isLoading && (
                        <span className={'loading-text'}>{intl.formatMessage({ id: `${LOCALE_PREFIX}.loading` })}</span>
                    )}
                    <ListTable
                        id={`${entId}-${docId}-pariticpants-list-table`}
                        isLoading={isLoading}
                        columnsDefinition={{
                            title: {
                                width: 175,
                                Cell: () => (
                                    <span>
                                        <FormattedMessage id={`${LOCALE_PREFIX}.contractingParties`} />
                                    </span>
                                ),
                            },
                            top: {
                                columns: [
                                    {
                                        accessor: 'name',
                                        Cell: (value) => (
                                            <Entity
                                                entity={_.get(value, 'value', null)}
                                                entId={_.get(value, 'original.id', null)}
                                                type={_.get(value, 'original.subjectType', null)}
                                                inactive={_.get(value, 'original.inactive', false)}
                                                value={_.get(value, 'value', '')}
                                            />
                                        ),
                                    },
                                    {
                                        accessor: 'type',
                                        Cell: (value) => <span>{_.get(value, 'value', null)}</span>,
                                    },
                                    {
                                        width: 150,
                                        accessor: 'indicators',
                                        Cell: (value) => (
                                            <div>
                                                <Signals
                                                    id={_.get(value, 'original.id', null)}
                                                    caution={_.get(value, 'value.caution')}
                                                    notice={_.get(value, 'value.notice')}
                                                    risk={_.get(value, 'value.risk')}
                                                />
                                            </div>
                                        ),
                                    },
                                ],
                            },
                        }}
                        staticData={{
                            _table: [
                                {
                                    key: `${entId}-${docId}-participants-list-_table`,
                                    tables: [
                                        {
                                            rows: participants || [],
                                        },
                                    ],
                                },
                            ],
                        }}
                        texts={{
                            loading: intl.formatMessage({ id: `${LOCALE_PREFIX}.loading` }),
                            noData: intl.formatMessage({ id: `${LOCALE_PREFIX}.noDataTable` }),
                            controlExpand: intl.formatMessage({ id: `${LOCALE_PREFIX}.controlExpand` }),
                            controlMore: intl.formatMessage({ id: `${LOCALE_PREFIX}.controlMore` }),
                            controlLess: intl.formatMessage({ id: `${LOCALE_PREFIX}.controlLess` }),
                            controlAll: intl.formatMessage({ id: `${LOCALE_PREFIX}.controlAll` }),
                            controlClose: intl.formatMessage({ id: `${LOCALE_PREFIX}.controlClose` }),
                            controlFirst: intl.formatMessage({ id: `${LOCALE_PREFIX}.controlFirst` }),
                        }}
                    />
                </div>
            </div>
        )
    }
}
